import { ReactNode } from 'react';

import * as Cta from '@/components/Cta';
import * as Section from '@/components/Section';
import { StrapiGridRevealBlock } from '@/types/blocks';
import { Prose } from '@/ui/Prose';

import { RichTextRenderer } from './RichTextRenderer';

export type GridRevealBlockContentProps = Pick<
    StrapiGridRevealBlock,
    'callsToAction' | 'title' | 'content'
> & {
    children?: ReactNode;
};

export function GridRevealBlockContent({
    callsToAction,
    children,
    content,
    title,
}: GridRevealBlockContentProps) {
    return (
        <>
            <header className="mb-md">
                <Section.Heading as="h3">{title}</Section.Heading>
            </header>

            {content && (
                <Prose>
                    <RichTextRenderer content={content} />
                </Prose>
            )}

            {children}

            {callsToAction && callsToAction?.length > 0 && (
                <div className="mt-sm flex space-x-sm lg:mt-md">
                    {callsToAction.map(({ id, ...cta }) => (
                        <Cta.Button {...cta} key={id} />
                    ))}
                </div>
            )}
        </>
    );
}
